module.exports = __webpack_public_path__ + "static/media/Logo-Liftit.4da38a85.svg";